// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"360":"sql-formatter","384":"jspdf","502":"vendor","526":"html2canvas"}[chunkId] + "." + {"360":"208b793d7bb8c514d009","384":"5ff05242d28feeb22d40","502":"69a8bb1f2871e696b87f","526":"f500b77ca409a3637245"}[chunkId] + ".js";
};